import {DateInput, DateInputProps} from "@blueprintjs/datetime";
import * as React from "react";

import {DayFormats, getDayFormatter, localTimeZone} from "../../../utils/date-util";

type MomentDateInputProps = Omit<
    DateInputProps,
    "formatDate" | "parseDate" | "value" | "defaultValue" | "onChange"
> & {
    value?: Date | null;
    defaultValue?: Date | null;
    onChange?: (value: Date | null, isUserChange: boolean) => void;
};

export class MomentDateInput extends React.Component<MomentDateInputProps> {
    private handleChange = (value: string | null, isUserChange: boolean) => {
        this.props.onChange?.(value ? new Date(value) : null, isUserChange);
    };

    public render() {
        const {value, defaultValue, popoverProps, ...rest} = this.props;
        return (
            <DateInput
                {...getDayFormatter(DayFormats.datetimeMinute)}
                reverseMonthAndYearMenus={true}
                maxDate={new Date(Date.now() + 1000 * 60 * 60 * 24 * 365)}
                value={value ? value.toISOString() : null}
                defaultValue={defaultValue ? defaultValue.toISOString() : undefined}
                onChange={this.handleChange}
                timezone={localTimeZone}
                defaultTimezone={localTimeZone}
                showTimezoneSelect={false}
                disableTimezoneSelect={true}
                popoverProps={{
                    placement: "bottom-start",
                    ...popoverProps,
                }}
                {...rest}
            />
        );
    }
}
